export default __webpack_public_path__ + "static/media/ep-img.ca951104.jpg";